import { clearClientSession } from '@/application/auth/clearClientSession';

export async function logoutAndRedirectToLogin() {
  clearClientSession();
  window.location.href = '/log-in';
}

const useLogout = () => logoutAndRedirectToLogin;

export default useLogout;
